import React from 'react';
import { FiMaximize, FiX } from 'react-icons/fi';

/**
 * My Ground maximize toggle — expands map into the content area (nav stays).
 * Parent owns maximized state so AppChromeHeader can hide while maximized.
 * Desktop: labeled button left of the Mapbox tool stack.
 * Mobile: Feather maximize icon in the top-right corner, same 20px size as
 * Mapbox geo tools. Maximized: compact X exit.
 */
export function MyGroundMaximizeControl({ maximized = false, onToggle }) {
  if (typeof onToggle !== 'function') return null;

  return (
    <button
      type="button"
      className={`my-ground-maximize-toggle y-btn ${
        maximized ? 'y-btn-primary my-ground-maximize-toggle--exit' : 'y-btn-secondary'
      }`}
      data-testid="my-ground-maximize-toggle"
      aria-pressed={maximized}
      aria-label={maximized ? 'Exit fullscreen map' : 'Maximize map'}
      title={maximized ? 'Exit fullscreen' : 'Maximize map'}
      onClick={onToggle}
    >
      {maximized ? (
        <FiX aria-hidden="true" />
      ) : (
        <>
          <span className="my-ground-maximize-toggle__label">Maximize map</span>
          <FiMaximize className="my-ground-maximize-toggle__icon" aria-hidden="true" />
        </>
      )}
    </button>
  );
}
